module.exports = __webpack_public_path__ + "img/27.c412f6ae.png";